import { css } from '@emotion/react'
import { Button, DropdownItem, HFlow, Icon, Theme, Tooltip, useTheme } from 'bold-ui'
import { Divider } from 'components/divider/Divider'
import { DropdownButton } from 'components/dropdown'
import { FieldStatusEnum, fieldStatusRecord } from 'components/form'

interface ListFieldStatusProps {
  status: FieldStatusEnum
  onReset: () => void
  onRemove: () => void
  children?: React.ReactNode
}

export const ListFieldStatus = (props: ListFieldStatusProps) => {
  const { status, onReset, onRemove, children } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const isResetDisabled = status === FieldStatusEnum.NAO_MODIFICADO || status === FieldStatusEnum.ADICIONADO
  const fieldStatusConfig = fieldStatusRecord[status]
  const hasChildren = !!children

  return (
    <HFlow hSpacing={0} justifyContent='flex-end'>
      <HFlow alignItems='center' hSpacing={0.5} justifyContent='flex-end'>
        <HFlow style={styles.status} hSpacing={0.5}>
          {fieldStatusConfig && (
            <Tooltip text={fieldStatusConfig.value}>
              <Icon icon={fieldStatusConfig.icon} size={1} />
            </Tooltip>
          )}
        </HFlow>
        <Tooltip
          text={
            isResetDisabled
              ? 'Só é possível restaurar para o estado original um registro que foi modificado'
              : 'Reverter mudanças'
          }
        >
          <Button skin='ghost' size='small' kind='normal' onClick={onReset} disabled={isResetDisabled}>
            <Icon icon='undo' />
          </Button>
        </Tooltip>
      </HFlow>
      <Tooltip
        text={status === FieldStatusEnum.REMOVIDO ? 'Para alterar um registro removido, é preciso restaurá-lo' : ''}
      >
        <DropdownButton disabled={status === FieldStatusEnum.REMOVIDO}>
          {children}
          {hasChildren && <Divider style={styles.divider} />}
          <DropdownItem type='danger' onClick={onRemove}>
            <HFlow alignItems='center' hSpacing={0.5}>
              <Icon icon='trashOutline' />
              Excluir
            </HFlow>
          </DropdownItem>
        </DropdownButton>
      </Tooltip>
    </HFlow>
  )
}

const createStyles = (theme: Theme) => ({
  status: css`
    color: ${theme.pallete.primary.main};
    display: flex;
    align-items: center;
  `,
  divider: css`
    margin: 0.25rem 0;
  `,
})
